import { useFormContext } from 'react-hook-form';
import type { IApplicationFormStep } from '@/features/ApplicationForm/types';
import { ApplicationFormInputRenderer } from '../ApplicationFormInputRenderer';

interface IApplicationFromSectionsProps {
  step: IApplicationFormStep;
  currentStep: number;
}

const ApplicationFormSections = (props: IApplicationFromSectionsProps) => {
  const { step, currentStep } = props;
  const { sections = [], component: Component } = step;
  const { watch } = useFormContext();
  const values = watch();

  if (Component) {
    return <Component />;
  }
  return (
    <>
      {sections.map((section) => (
        <ApplicationFormInputRenderer key={section.id} section={section} formValues={values} currentStep={currentStep} />
      ))}
    </>
  );
};

export default ApplicationFormSections;
